export enum SidebarType {
  APP = 'APP',
}

export interface Sidebar {
  type: SidebarType
  params?: { [key: string]: string | number | boolean | null }
}

export enum SidebarSlug {
  MODERATION = 'moderation',
  COMMENTS = 'comments',
  PROFILES = 'profiles',
  TOPICS = 'topics',
  TOPICS_MODERATION = 'topics-moderation',
}
